import { EmployeeExportSelectionTable } from '../../lib/components/tables/employee/employeeExportSelection';
import { KeyofNamespace } from '../../translations/keyofNs';
import { ExportConclusion } from './steps/conclusion';
import { ExportOptions } from './steps/options';
import { ExportSummary } from './steps/summary';

export type ExportStep = {
  component: React.ComponentType;
  title: string;
  headerTitle?: string;
  validation?: (
    data: Record<string, unknown>
  ) => true | KeyofNamespace<'export'> | Promise<true | KeyofNamespace<'export'>>;
};

export type ExportFlow = {
  type: string;
  steps: ExportStep[];
};

const allSteps = [
  {
    component: EmployeeExportSelectionTable,
    title: 'export:CREATE_STEPPER_EMPLOYEE',
    headerTitle: 'export:CREATE_SECTION_TITLE_EMPLOYEE',
    validation: (data: { employees_query?: { ids?: string[] } }) => {
      return data.employees_query?.ids?.length ? true : 'ERROR_NO_EMPLOYEE_SELECTED';
    }
  },
  {
    headerTitle: 'export:CREATE_SECTION_TITLE_EXPORT_OPTIONS',
    component: ExportOptions,
    title: 'export:CREATE_STEPPER_EXPORT_OPTIONS',
    validation: (data: { format?: string }) => {
      return data.format ? true : 'ERROR_NO_FORMAT_SELECTED';
    }
  },
  {
    headerTitle: 'export:CREATE_SECTION_TITLE_SUMMARY',
    component: ExportSummary,
    title: 'export:CREATE_STEPPER_SUMMARY'
  },
  {
    component: ExportConclusion,
    title: 'export:CREATE_STEPPER_FINISHED'
  }
];

export const exportFlows: Record<string, ExportFlow> = {
  employee_data: {
    type: 'employee_data',
    steps: allSteps
  },
  receipts: {
    type: 'receipts',
    steps: allSteps
  },
  payroll_data: {
    type: 'payroll_data',
    steps: allSteps
  },
  voucher_orders: {
    type: 'voucher_orders',
    steps: allSteps.slice(1)
  }
};
